<template>
    <v-simple-table dense>
        <tbody>
            <tr>
                <td>Nama</td>
                <td>{{ user.name }}</td>
            </tr>
            <tr>
                <td>Email</td>
                <td>{{ user.email }}</td>
            </tr>
            <tr>
                <td>Username</td>
                <td>{{ user.username }}</td>
            </tr>
            <tr>
                <td>Kontak</td>
                <td>{{ user.contact }}</td>
            </tr>
            <tr>
                <td>Mendaftar</td>
                <td>{{ createdAt }}</td>
            </tr>
        </tbody>
    </v-simple-table>
</template>

<script>
import { parseFromServer } from '@/plugins/moment'

export default {
    props: {
        user: {
            type: Object,
        }
    },

    computed: {
        createdAt() {
            return parseFromServer(this.user.created_at).formatShortDayAndTime()
        }
    }
}
</script>
